import { Button, Heading, Modal, Text, VStack } from 'native-base'

import { TermsAndConditions } from '../TermAndConditions/TermsAndConditions'
import { AddInstructionsLaterButton } from './AddInstructionsLaterButton'
import { ToastAlertProps } from './ToastAlert'

export interface ModalContentProps {
  headerMain: string
  headerSecondary: string
  submitText: string
  onSubmit: () => void
  closeModal: ({
    clearAddressFields,
    clearGeocode,
    showToast,
    toastProps,
  }: {
    clearAddressFields?: boolean
    clearGeocode?: boolean
    showToast?: boolean
    toastProps?: ToastAlertProps
  }) => void
  disabled: boolean
  loading: boolean
  children?: React.ReactNode
  cancelText?: string
  submitButtonStyles?: object
  modalStyles?: object
  useAddInstructionsLaterButton?: boolean
  cancelButtonStyles?: object
  headerContainerStyles?: object
  headerMainStyles?: object
  headerMainChildren?: React.ReactNode
  headerSecondaryStyles?: object
  includeTermsAndConditions?: boolean
  termsAndConditionsAction?: string
}

export const ModalContent = ({
  headerMain,
  headerSecondary,
  submitText,
  onSubmit,
  closeModal,
  disabled,
  loading,
  children,
  cancelText,
  submitButtonStyles,
  modalStyles,
  useAddInstructionsLaterButton = true,
  cancelButtonStyles,
  headerContainerStyles,
  headerMainStyles,
  headerSecondaryStyles,
  headerMainChildren,
  includeTermsAndConditions,
  termsAndConditionsAction,
}: ModalContentProps) => {
  return (
    <Modal.Content
      alignItems={'stretch'}
      overflowY={'auto'}
      bg={'brand.warmWhite'}
      width={350}
      maxWidth={'90svw'}
      maxHeight={'95svh'}
      style={{ ...modalStyles }}
    >
      <VStack space={4} alignItems={'center'} p={3} my={3}>
        <VStack space={1} alignItems={'center'} w={'100%'} {...headerContainerStyles}>
          {headerMainChildren ? (
            headerMainChildren
          ) : (
            <Heading textAlign={'center'} {...headerMainStyles}>
              {headerMain}
            </Heading>
          )}
          <Text textAlign={'center'} {...headerSecondaryStyles}>
            {headerSecondary}
          </Text>
        </VStack>
        {children}
        <VStack space={1} alignItems={'center'} w={'100%'}>
          {includeTermsAndConditions && <TermsAndConditions action={termsAndConditionsAction} isDisabled={loading} />}
          <Button onPress={onSubmit} isDisabled={disabled} isLoading={loading} style={{ ...submitButtonStyles }}>
            {submitText}
          </Button>
          {useAddInstructionsLaterButton ? (
            <AddInstructionsLaterButton closeModal={closeModal} cancelText={cancelText} />
          ) : (
            <Button
              onPress={() =>
                closeModal({
                  clearAddressFields: false,
                  clearGeocode: false,
                  showToast: false,
                })
              }
              style={{ ...cancelButtonStyles }}
            >
              {cancelText}
            </Button>
          )}
        </VStack>
      </VStack>
    </Modal.Content>
  )
}
